import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';

const Screen = lazy(() =>
  import('../screens/Audit/AuditScreen').then(m => ({ default: m.AuditScreen })),
);

export const Route = createFileRoute('/audit')({
  component: () => (
    <Suspense fallback={<div style={{ padding: 32, color: 'var(--lca-gray-500)', fontSize: 13 }}>Loading…</div>}>
      <Screen />
    </Suspense>
  ),
});
